import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useWeather } from '../../data/weather.tsx';
import { activeAlerts, freshSource, weatherNoticeKey } from '../../engine/weather.ts';
// This strip appears on every page except the weather page itself, so the
// weather stylesheet loads with the app shell rather than with that route.
import '../../styles/weather.css';

const DISMISSED_KEY = 'festival-dismissed-weather-notice';

export function WeatherNotice() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISSED_KEY); } catch { return null; }
  });
  const { snapshot, now, offline, failed, loading } = useWeather();
  const alerts = activeAlerts(snapshot?.alerts.data ?? [], now);
  const current = !offline && !failed && freshSource(snapshot?.alerts, now);
  const noticeKey = weatherNoticeKey(alerts, current);
  if (!snapshot && loading) return null;
  if (current && alerts.length === 0) return null;
  if (dismissed === noticeKey) return null;
  return <aside className={`notice weather-notice ${alerts.length ? 'bad' : ''}`} aria-label="Weather status">
    <div className="weather-notice-content">
      <strong>{alerts.length ? alerts.map(a => a.event).join(' · ') : 'Alert status unverified'}</strong>
      {!current && <span>Saved data is out of date.</span>}
      <Link to="/weather">Weather and radar</Link>
    </div>
    <button type="button" className="weather-notice-dismiss" aria-label="Dismiss weather notice" onClick={() => {
      setDismissed(noticeKey);
      try { sessionStorage.setItem(DISMISSED_KEY, noticeKey); } catch { /* Dismissal still works for this page. */ }
    }}><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg></button>
  </aside>;
}
